import React from "react";
import ServiceGroupCrudTableRow from "./ServiceGroupCrudTableRow";

const ServiceGroupCrudTable = ({groups, editData, deleteData}) => {


    const styles = {
        tablegroup: {
            width: "100%",
            opacity: "0.8",
            borderRadius: '5px'
        },
        thgroup: {
            border: "1px solid black",
            borderRadius: '5px',
        },
        cell2: {
            padding: "15px"
        }, 
    }

    return (
        <div>
            <table className="table-striped" style={styles.tablegroup}>
                <thead>
                    <tr>
                        <th style={styles.cell2} scope="col">#</th>
                        <th style={styles.cell2} scope="col">Código</th>
                        <th style={styles.cell2} scope="col">Nombre</th>
                        <th style={styles.cell2} scope="col">Descripción</th>
                        <th style={styles.cell2} scope="col">Servicios</th>
                        <th style={styles.cell2} scope="col">Visible</th>
                        <th style={styles.cell2} scope="col">Acción</th>
                    </tr>
                </thead>
                <tbody>
                {groups.length > 0 ? groups.map((el, i) => <ServiceGroupCrudTableRow key={el._id} el={el} i={i}
                        editData={editData}
                        deleteData={deleteData}
                        styles={styles}  />) :
                        <tr>
                            <td colSpan="5">Sin datos</td>
                        </tr>
                }
                </tbody>
            </table>
        </div>
    );
}
export default ServiceGroupCrudTable;
